import React from "react";
import clases from './Topbar.module.css'

const Topbar = () =>{
    return(
        <header className="App-header">
          
        <nav className= {clases.Topbar}>

        <img src='https://png.pngtree.com/png-clipart/20221001/original/pngtree-shopping-logo-design-for-online-store-website-png-image_8647300.png' alt="Tienda Logo" />
        <div>
        <a className={clases.item} href="" >Home</a>
         <a className={clases.item} href="">Contacts</a>
         <a className={clases.item} href="" >About</a>
        
          </div>
     
      </nav>
      
      </header>
    );
}

export default Topbar;